import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  toolbar: {
    justifyContent: 'flex-end'
  }
});

export default useStyles;
